export default "__VITE_ASSET__FaMxHjFf__"